export namespace PROVIDERS {
  const NO_PROVIDER = 'no provider';
  const GOOGLE = 'Google';
  const VINCI = 'Vinci-AzureAD';
  const EQUANS = 'Equans-AzureAD';
}
